import './MatchNote.scss';

import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import itsMacth from '../../../assets/images/MatchGame/itsMatch.png';
import keepPlaying from '../../../assets/images/MatchGame/keepPlaying.svg';
import sendMessage from '../../../assets/images/MatchGame/sendMessage.svg';
import MaleAvatar from '../../../assets/images/MembersAreaNavbar/ProfileAvatar.svg';
import ProfileAvatar from '../../../assets/images/Temp/ProfileImage.jpg';
import {
  myProfile,
  showMemberProfilePage,
  showMessagesPage,
} from '../../../pages/MainView/components/MembersAreaMain/navigation.service';
import { getUserData } from '../../../services/user-service/user.service';
import ButtonWithIcon from '../../ButtonWithIcon/ButtonWithIcon';
import ImageN from '../../ImageN/ImageN';

const MatchNote = (props) => {
  const { matchProfile, closeModal, modalRef, matchName } = props;
  const userData = getUserData();
  const { profileAvatar } = useSelector((state) => state);
  const { gender } = userData.profile;
  console.log(gender);

  const setAvatarPicture = () => {
    if (profileAvatar) {
      return <ImageN name={profileAvatar} className="ProfilePhoto" classNameImg="ProfilePhoto" />;
    }
    return (
      <img
        className="ProfilePhoto"
        src={gender === 'female' ? ProfileAvatar : MaleAvatar}
        alt="Profile-Avatar"
      />
    );
  };

  const setUserPicture = useCallback(() => {
    // if (matchProfile?.profile_image) {
    //   return <ImageN src={matchProfile?.profile_image} className="ProfilePhoto"/>;
    // }
    // return (
    //   <img
    //   className="ProfilePhoto"
    //     src={ProfileAvatar}
    //     alt="Profile-Avatar"
    //   />
    // );

    console.log('matchProfile ==> ', matchProfile);

    return matchProfile.profile_image ? (
      <ImageN
        name={matchProfile.profile_image}
        className="ProfilePhoto"
        classNameImg="ProfilePhoto"
      />
    ) : (
      <img className="ProfilePhoto" src={ProfileAvatar} alt="Profile-Avatar" />
    );
  }, [profileAvatar, matchProfile.avatar_image]);

  const sendMessageToMacth = () => {
    showMessagesPage(matchProfile?.id);
  };

  const keepPlayingGame = () => {
    closeModal(modalRef);
  };

  return (
    <div className="MatchNote">
      <img src={itsMacth} className="itsMatch" />
      <p className="Subtitle">You and {matchName} liked each other!</p>
      <div className="ProfileWrapper">
        <div className="matchImageWrapper" onClick={() => myProfile()}>
          {setAvatarPicture()}
        </div>
        <div className="matchImageWrapper" onClick={() => showMemberProfilePage(matchProfile?.id)}>
          {setUserPicture()}
        </div>
      </div>
      <ButtonWithIcon
        className="MatchButton"
        text={'send message'}
        iconSrc={sendMessage}
        onClick={sendMessageToMacth}
      />
      <ButtonWithIcon
        className="MatchButton1"
        text={'keep playing'}
        iconSrc={keepPlaying}
        onClick={keepPlayingGame}
      />
    </div>
  );
};

export default MatchNote;
